/** Auth deployment target for report-engine token validation (must match backend map). */
export const AUTH_ENVIRONMENT = {
  DEV: "dev",
  PROD: "prod",
  CRE: "cre",
};

const ALLOWED = new Set(Object.values(AUTH_ENVIRONMENT));

/**
 * Resolve auth environment for integration calls (dictionary phrases, etc.).
 * Prefer REACT_APP_AUTH_ENVIRONMENT; otherwise infer from REACT_APP_BASE_URL / REACT_APP_ENV.
 */
export function resolveAuthEnvironment() {
  const explicit = String(process.env.REACT_APP_AUTH_ENVIRONMENT || "")
    .trim()
    .toLowerCase();
  if (explicit && ALLOWED.has(explicit)) {
    return explicit;
  }

  const base = String(process.env.REACT_APP_BASE_URL || "")
    .trim()
    .toLowerCase();

  if (base.includes("prod-cre-apim")) {
    return AUTH_ENVIRONMENT.CRE;
  }
  if (base.includes("prodradsforvets") || base.includes("prodrads")) {
    return AUTH_ENVIRONMENT.PROD;
  }
  if (process.env.REACT_APP_ENV === "test" || base.includes("devvets")) {
    return AUTH_ENVIRONMENT.DEV;
  }

  return AUTH_ENVIRONMENT.DEV;
}
